function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
import moment from 'moment';
import { serviceKey } from './service-option-conversion-service';
import { convertDateStringToDate, convertFormDataToFilesJson, convertJsonToSelectFieldValue, convertTimestampToDate } from './generics-conversion-service';
var processOrderDetails = function processOrderDetails(order) {
  return _objectSpread(_objectSpread({}, order), {}, {
    createdAt: order.createdAt ? convertTimestampToDate(order.createdAt) : '',
    deadline: order.deadline ? convertTimestampToDate(order.deadline) : '',
    completedAt: order.completedAt ? convertTimestampToDate(order.completedAt) : '',
    services: order.services.map(function (service, i) {
      return _objectSpread(_objectSpread({}, service), {}, {
        key: serviceKey(service, i)
      });
    })
  });
};
export var convertOrderSearchRequestToJson = function convertOrderSearchRequestToJson(json) {
  var orders = json.results.map(function (order) {
    return processOrderDetails(order);
  });
  return {
    pagination: json.pagination,
    orders: orders
  };
};
export var convertFormDataToOrderUpdateRequest = function convertFormDataToOrderUpdateRequest(data) {
  var _data$services;
  var orderDetails = {
    externalId: data.externalId,
    journal: data.journal.name.value ? {
      name: data.journal.name.value,
      url: data.journal.url
    } : undefined,
    answers: !_.isEmpty(data.answers) ? _.map(data.answers, function (answerValue, questionLabel) {
      return {
        questionLabel: questionLabel,
        answers: typeof answerValue === 'string' ? [answerValue] : answerValue
      };
    }) : [],
    deadline: data.deadline ? data.deadline.toISOString() : undefined,
    styleOfEnglish: data.styleOfEnglish,
    services: (_data$services = data.services) === null || _data$services === void 0 ? void 0 : _data$services.map(function (service) {
      return {
        serviceIdentity: service.serviceIdentity,
        figureCount: service.figureCount,
        tableCount: service.tableCount,
        turnaroundTime: service.turnaroundTime,
        wordCount: {
          min: service.wordCount.min,
          max: service.wordCount.max
        },
        type: service.type,
        name: service.name,
        variant: service.variant
      };
    }),
    title: data.title,
    files: convertFormDataToFilesJson(data)
  };
  return {
    orderDetails: orderDetails
  };
};
export var convertFormDataToOrderComplaintRequest = function convertFormDataToOrderComplaintRequest(data) {
  var orderDetails = {
    externalId: data.externalId,
    files: convertFormDataToFilesJson(data)
  };
  return {
    orderDetails: orderDetails
  };
};
export var convertOrderUpdateRequestToJson = function convertOrderUpdateRequestToJson(orderUpdateRequest) {
  var _orderUpdateRequest$e;
  var order = processOrderDetails(orderUpdateRequest.orderDetails);
  var error = ((_orderUpdateRequest$e = orderUpdateRequest.error) === null || _orderUpdateRequest$e === void 0 ? void 0 : _orderUpdateRequest$e.error) || null;
  return {
    order: order,
    error: error
  };
};
export var convertJsonToFormData = function convertJsonToFormData(json) {
  return {
    externalId: json.externalId,
    files: {},
    journal: {
      name: convertJsonToSelectFieldValue(json.journal ? json.journal.name : null, {
        label: json.journal ? json.journal.name : undefined
      }),
      url: json.journal ? json.journal.url : '',
      valid: true
    },
    deadline: moment(json.deadline).toDate(),
    styleOfEnglish: json.styleOfEnglish,
    services: json.services,
    title: json.title
  };
};
var cleanOrderSearchParams = function cleanOrderSearchParams(params) {
  var cleanedObject = {};
  _.each(params, function (paramValue, paramKey) {
    cleanedObject[paramKey] = !paramValue || paramValue === '_' || paramValue.length === 0 ? null : paramValue;
  });
  return cleanedObject;
};
export var parseOrderSearchDate = function parseOrderSearchDate(dateString) {
  var momentDate = moment(dateString, 'YYYY-MM-DD');
  if (!dateString || !momentDate.isValid()) {
    return '_';
  }
  return momentDate.format('YYYY-MM-DD');
};
export var convertOrderSearchJsonToFormData = function convertOrderSearchJsonToFormData(json) {
  var _cleanOrderSearchPara = cleanOrderSearchParams(json),
    from = _cleanOrderSearchPara.from,
    to = _cleanOrderSearchPara.to,
    xid = _cleanOrderSearchPara.xid,
    orderTitle = _cleanOrderSearchPara.orderTitle;
  return {
    from: from ? convertDateStringToDate(from) : null,
    orderTitle: orderTitle || '',
    to: to ? convertDateStringToDate(to) : null,
    xid: xid || ''
  };
};
export var convertFormDataToOrderSearchJson = function convertFormDataToOrderSearchJson(_ref) {
  var xid = _ref.xid,
    orderTitle = _ref.orderTitle,
    from = _ref.from,
    to = _ref.to;
  return {
    xid: xid || null,
    orderTitle: orderTitle || null,
    from: from ? from.toISOString() : null,
    to: to ? to.toISOString() : null
  };
};